import { admin } from "./axios";
import { IPostIngestionDatesResult } from "../../interface/IPostIngestionDates";

export interface PostIngestionDatesApiResponse {
  status: string;
  statusCode: number;
  message: string;
  data: IPostIngestionDatesResult;
}

export const getPostIngestionDates = async (
  limit = 5
): Promise<IPostIngestionDatesResult> => {
  const response = await admin.get<PostIngestionDatesApiResponse>(
    "posts/ingestion-dates",
    { params: { limit } }
  );

  return response.data.data;
};
